import LegalPage from "@/pages/LegalPage";

const SECTIONS = [
  {
    h: "Who we are",
    body: [
      "Haven and Hill Properties L.L.C (\u201cwe\u201d, \u201cus\u201d) is a real-estate brokerage and advisory based in Dubai, United Arab Emirates. For the purposes of UAE Federal Decree-Law No. 45 of 2021 on the Protection of Personal Data (PDPL), we are the data controller for personal data collected through this website.",
      "Contact: support@havenandhillproperties.com \u00b7 WhatsApp +971 58 812 3628 \u00b7 Dubai, United Arab Emirates.",
    ],
  },
  {
    h: "What we collect",
    body: [
      "Contact details you give us directly: name, email address and phone number when you book a consultation, request a virtual viewing, purchase or download the buyer's guide, or correspond with us.",
      "Appointment and transaction details: preferred meeting mode and time, buyer category, messages you send, and payment confirmations (card details themselves are processed by Razorpay and never touch our servers).",
      "Chat conversations with our AI concierge, used to answer your questions and improve response quality.",
      "Technical data: pages visited and device/browser information. Checklist progress and chat session identifiers are stored locally on your device (localStorage), not on our servers.",
    ],
  },
  {
    h: "How we use it",
    body: [
      "To respond to enquiries, arrange and confirm consultations (including reminder emails), deliver purchased or requested content such as the buyer's guide, and manage listings and viewings you ask about.",
      "To send occasional market notes and offers where you have opted in — every such email includes a way to stop them.",
      "To meet legal and regulatory obligations, including record-keeping expected of brokerages by the Dubai Land Department and RERA.",
    ],
  },
  {
    h: "Legal bases (PDPL)",
    body: [
      "We process personal data on the bases recognised by the PDPL: your consent (for example when you submit a form or opt into updates), performance of a contract or steps towards one (delivering the guide, arranging consultations), legitimate interest (responding to enquiries, improving our services, preventing fraud), and legal obligation.",
    ],
  },
  {
    h: "Who we share it with",
    body: [
      "Service providers acting on our instructions: Razorpay (payments), our email delivery provider, and Zoom (meeting links). These parties process data only as needed to provide their service.",
      "We never sell your personal data. We disclose it to authorities only where UAE law requires it.",
    ],
  },
  {
    h: "Retention and security",
    body: [
      "We keep personal data only as long as needed for the purposes above and applicable regulatory record-keeping, then delete or anonymise it. We apply appropriate technical and organisational measures to protect it.",
    ],
  },
  {
    h: "Your rights",
    body: [
      "Under the PDPL you may request access to, rectification or erasure of your personal data, restrict or object to its processing, and withdraw consent at any time without affecting prior lawful processing. Email support@havenandhillproperties.com and we will respond within a reasonable period.",
      "You may also raise concerns with the UAE Data Office.",
    ],
  },
  {
    h: "Cookies and local storage",
    body: [
      "This site does not use tracking cookies. It uses your browser's local storage for convenience features (checklist progress, chat session continuity) and a secure session cookie for admin sign-in only.",
    ],
  },
  {
    h: "Changes",
    body: [
      "We may update this policy as laws or our services evolve; the \u201clast updated\u201d date above shows the current version.",
    ],
  },
];

export default function Privacy() {
  return (
    <LegalPage
      title="Privacy Policy"
      updated="July 2026"
      path="/privacy"
      description="How Haven & Hill Properties collects, uses and protects personal data under UAE Federal Decree-Law No. 45 of 2021 (PDPL)."
      intro="This policy explains what personal data we collect through havenandhillproperties.com, why, and the rights you have under UAE data-protection law."
      sections={SECTIONS}
    />
  );
}
